import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {BaseDirectSaleVariant} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromDirectSaleVariants = (
  directSaleVariants: BaseDirectSaleVariant[] | Nullish
): Option[] => {
  if (isNil(directSaleVariants)) {
    return [];
  }
  return directSaleVariants.map((directSaleVariant) => ({
    label: directSaleVariant.name,
    value: directSaleVariant.directSaleVariantId,
  }));
};
